import React from 'react'
import Typography from '@material-ui/core/Typography';
import {NewTaskContainer} from '@components/user-tasks/modals/new-task/new-task.container'
import {OrderDetailsContainer} from '@components/orders/modals/order-details/order-details.container';
import {SimpleDialog} from "@components/form/SimpleDialog";
import {TaskReportContainer} from '@components/user-tasks/modals/task-report/task-report.container';
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import QueryBuilderOutlinedIcon from '@material-ui/icons/QueryBuilderOutlined';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import LinkOutlinedIcon from '@material-ui/icons/LinkOutlined';
import SubjectOutlinedIcon from '@material-ui/icons/SubjectOutlined';
import AssessmentOutlinedIcon from '@material-ui/icons/AssessmentOutlined';
import AssignmentLateOutlinedIcon from '@material-ui/icons/AssignmentLateOutlined';
var dayjs = require('dayjs')
import 'dayjs/locale/ru'

export class TaskInfoComponent extends React.Component {

    state = {
        open: false
    }

    deleteTask = async(id) => {
        let response = await this.props.deleteUserTask(id);
        if (!response.errors) {
            this.setState({open: false});
            if (this.props.onTaskDelete) {
                this.props.onTaskDelete(this.props.task);
            } else {
                history.go();
            }
        }
    }

    render() {
        const {task, classes, customOpenButton} = this.props;

        let reminder_type,
            entity_type,
            entity_id,
            status,
            is_done = false;

        switch (task.reminder_type) {
            case 'task' : reminder_type = 'Задача'; break;
            default: reminder_type = 'Другое';
        }

        switch (task.entity_type) {
            case 'order' :
                entity_type = <OrderDetailsContainer
                    customOpenButton={<span
                        className={classes.spanOpenDialogButton}
                        style={{margin: 0}}
                    >Заказ (просмотреть детали)</span>}
                    orderId={task.entity_id}
                />;
                break
            default: entity_type = 'Другое'; entity_id = 'Нет связи'
        }

        switch (task.status) {
            case 'active' :
                status = <>
                    Активна
                    <TaskReportContainer
                        taskId={task.id}
                        openIcon={<span className={classes.span_button}> (завершить)</span>}
                        is_report_required={task.is_report_required}
                        onStatusChange={(newTask) => {
                            this.props.onTaskUpdate(newTask);
                            this.setState({open: false});
                        }}
                    />
                </>; break
            case 'done':
                status = 'Выполнена'; is_done = true; break
            default: status = '–';
        }

        return (<SimpleDialog
            fullWidth={true}
            maxWidth={'md'}
            open={this.state.open}
            onClose={(e) => this.setState({open: false})}
            title={task.title}
            icon={customOpenButton
                ? <div onClick={e => this.setState({open : true})}>{customOpenButton}</div>
                : <div
                    style={{
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        top: '0',
                        left: '0',
                    }}
                    onClick={(e) => this.setState({open: true})}>
                </div>}
            disableActions
            headerActions={[
                <NewTaskContainer
                    task={task}
                    onSubmitRedirect={this.props.onTaskUpdate}
                />,
                <DeleteOutlineOutlinedIcon
                    color={'primary'}
                    onClick={(e) => this.deleteTask(task.id)}
                />
            ]}
        >
            {/*<div className={classes.taskRow}>*/}
            {/*    <div className={classes.taskRow_type}>*/}
            {/*        <PersonOutlineOutlinedIcon />*/}
            {/*        <Typography>Исполнитель:</Typography>*/}
            {/*    </div>*/}
            {/*    <div className={classes.taskRow_value}>*/}
            {/*        <Typography></Typography>*/}
            {/*    </div>*/}
            {/*</div>*/}

            <div className={classes.taskRow}>
                <div className={classes.taskRow_type}>
                    <QueryBuilderOutlinedIcon />
                    <Typography>Время:</Typography>
                </div>
                <div className={classes.taskRow_value}>
                    <Typography>{`${dayjs(task.reminder_start).format('DD.MM.YYYY')}, ${dayjs(task.reminder_start).format('HH:mm')} – ${dayjs(task.reminder_end).format('HH:mm')}`}</Typography>
                </div>
            </div>

            <div className={classes.taskRow}>
                <div className={classes.taskRow_type}>
                    <InfoOutlinedIcon />
                    <Typography>Тип:</Typography>
                </div>
                <div className={classes.taskRow_value}>
                    <Typography>{reminder_type}</Typography>
                </div>
            </div>

            <div className={classes.taskRow}>
                <div className={classes.taskRow_type}>
                    <LinkOutlinedIcon />
                    <Typography>Связь:</Typography>
                </div>
                <div className={classes.taskRow_value}>
                    <Typography>{entity_type}</Typography>
                </div>
            </div>

            <div className={classes.taskRow}>
                <div className={classes.taskRow_type}>
                    <SubjectOutlinedIcon />
                    <Typography>Описание:</Typography>
                </div>
                <div className={classes.taskRow_value}>
                    <Typography align={'justify'}>{task.comment}</Typography>
                </div>
            </div>

            <div className={classes.taskRow}>
                <div className={classes.taskRow_type}>
                    <InfoOutlinedIcon />
                    <Typography>Статус:</Typography>
                </div>
                <div className={classes.taskRow_value}>
                    <Typography align={'justify'}>{status}</Typography>
                </div>
            </div>

            <div className={classes.taskRow}>
                <div className={classes.taskRow_type}>
                    <AssignmentLateOutlinedIcon />
                    <Typography>Отчет по завершению:</Typography>
                </div>
                <div className={classes.taskRow_value}>
                    <Typography align={'justify'}>{!!task.is_report_required ? 'Требуется' : 'Не требуется'}</Typography>
                </div>
            </div>

            {!!task.is_report_required && is_done ? <div className={classes.taskRow}>
                <div className={classes.taskRow_type}>
                    <AssessmentOutlinedIcon/>
                    <Typography>Отчет:</Typography>
                </div>
                <div className={classes.taskRow_value}>
                    <Typography align={'justify'}>
                        <TaskReportContainer
                            report={task.report}
                        />
                    </Typography>
                </div>
            </div> : null}
        </SimpleDialog>)
    }
}

